/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Sub_Addons_Confirm_Copilot_Enable_DescInputs */



/**
* | output |
* | --- |
* | "A prorated charge of approximately €{total} will be added to your current invoice for the remaining days in this billing period. After that, €{total}/mo will..." |
*
* @param {Sub_Addons_Confirm_Copilot_Enable_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_copilot_enable_desc = /** @type {((inputs: Sub_Addons_Confirm_Copilot_Enable_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Copilot_Enable_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Eine anteilige Gebühr von ca. €${i?.total} wird Ihrer aktuellen Rechnung für die verbleibenden Tage hinzugefügt. Danach erscheinen €${i?.total}/Mo. auf jeder Rechnung.`)
	return /** @type {LocalizedString} */ (`A prorated charge of approximately €${i?.total} will be added to your current invoice for the remaining days in this billing period. After that, €${i?.total}/mo will appear on each invoice.`)
});